<script setup lang="ts">
    import type { AiMessage, FreeLineData, CreateContactData, CreateWorksiteData } from '~/stores/aiAssistantTypes';
    import { AI_ROLE, AI_MESSAGE_TYPE } from '~/stores/aiAssistantTypes';

    const props = defineProps<{
        message: AiMessage;
    }>();

    defineEmits<{
        (e: 'option-selected', value: string, metadata?: Record<string, any>): void;
        (e: 'submit-form', parentMessageId: string, formMessageId: string, payload: { freeLineData?: FreeLineData; createContactData?: CreateContactData; createWorksiteData?: CreateWorksiteData; selectedExistingUuid?: string }): void;
        (e: 'cancel-form', formMessageId: string): void;
        (e: 'open-inline-form', parentMessageId: string, value: string): void;
    }>();

    const isFile = computed(() => props.message.type === AI_MESSAGE_TYPE.FILE);
    const isInteractive = computed(() => props.message.type === AI_MESSAGE_TYPE.INTERACTIVE);
    const isInlineForm = computed(() => props.message.type === AI_MESSAGE_TYPE.INLINE_FORM);
</script>

<template>
    <AiMessageAiUserFileMessage
        v-if="message.role === AI_ROLE.USER && isFile"
        :message="message"
    />
    <AiMessageAiUserMessage
        v-else-if="message.role === AI_ROLE.USER"
        :message="message"
    />
    <AiMessageAiInteractiveMessage
        v-else-if="isInteractive"
        :message="message"
        @option-selected="(value, metadata) => $emit('option-selected', value, metadata)"
        @open-inline-form="(value) => $emit('open-inline-form', message.id, value)"
    />
    <AiMessageAiInlineFormMessage
        v-else-if="isInlineForm"
        :message="message"
        @submit-form="(parentId, formId, payload) => $emit('submit-form', parentId, formId, payload)"
        @cancel-form="(formId) => $emit('cancel-form', formId)"
    />
    <AiMessageAiNarrationPill
        v-else-if="message.narration"
        :message="message"
    />
    <AiMessageAiAssistantMessage
        v-else
        :message="message"
    />
</template>
